import React, { useLayoutEffect, useRef } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

const GenderBarChart = ({ selectedProvince, selectedLocalMarket, data }) => {
  const chartRef = useRef(null);

  useLayoutEffect(() => {
    if (chartRef.current) {
      chartRef.current.dispose();
    }

    let chart = am4core.create('genderbarchart', am4charts.XYChart3D);
    chartRef.current = chart;

    chart.paddingBottom = 30;
    chart.angle = 35;
    chart.logo.disabled = true;

    const sortData = (data) => {
      return data.sort((a, b) => {
        const getYearValue = (year) => {
          if (typeof year === 'number') return year;
          if (year === 'May-24') return 2024.4;
          if (year === 'Oct-24') return 2024.8;
          return parseFloat(year);
        };
        return getYearValue(a.Year) - getYearValue(b.Year);
      });
    };

    chart.data = sortData([...data]);

    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'Year';
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.labels.template.disabled = false;
    categoryAxis.renderer.minGridDistance = 30;    
    categoryAxis.numberFormatter.numberFormat = '#'; 

    categoryAxis.renderer.labels.template.adapter.add("text", (text) => {
      return text;  
    });

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.renderer.grid.template.disabled = true;

    const createSeries = (field, name, color) => {
      let series = chart.series.push(new am4charts.ColumnSeries3D());
      series.dataFields.valueY = field;
      series.dataFields.categoryX = 'Year';
      series.name = name;
      series.stacked = true;      
      
      series.columns.template.tooltipText = 
        '[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}%';
      
      series.columns.template.fill = color;
      series.columns.template.stroke = color;
    
      let label = series.bullets.push(new am4charts.LabelBullet());
      label.label.text = '{valueY}%';
      label.label.fill = am4core.color('#ffffff');
      label.label.fontSize = 12;
      label.label.horizontalCenter = 'middle';
      label.label.verticalCenter = 'middle';
      label.locationY = 0.5;

      // Add adapter for small values
      label.label.adapter.add("visible", (visible, target) => {
        return target.dataItem.valueY > 5; 
      });
    };

    createSeries('male', 'Male', am4core.color('#5D8AA8'));
    createSeries('female', 'Female', am4core.color('#FF69B4'));

    // Configure legend
    chart.legend = new am4charts.Legend();
    chart.legend.position = 'bottom';
    chart.legend.contentAlign = 'center';

    // Add a title if province or local market is selected
    if (selectedProvince || selectedLocalMarket) {
      let title = chart.titles.create();
      title.text = [
        selectedProvince && `Province: ${selectedProvince}`,
        selectedLocalMarket && `Local Market: ${selectedLocalMarket}`,
      ].filter(Boolean).join(' | ');
      title.fontSize = 14;
      title.marginBottom = 20;
    }

    return () => {
      if (chartRef.current) {
        chartRef.current.dispose();
        chartRef.current = null;
      }
    };
  }, [selectedProvince, selectedLocalMarket]); 

  useLayoutEffect(() => {
    if (chartRef.current && data) {
    
      const sortedData = [...data].sort((a, b) => {
        const getYearValue = (year) => {
          if (typeof year === 'number') return year;
          if (year === 'May-24') return 2024.4;
          if (year === 'Oct-24') return 2024.8;
          return parseFloat(year);
        };
        return getYearValue(a.Year) - getYearValue(b.Year);
      });
      
      chartRef.current.data = sortedData;
    }
  }, [data]);

  return <div id="genderbarchart" style={{ width: '100%', height: '500px' }}></div>;
};

export default GenderBarChart;